import React from 'react';
import {InPageAlert} from '@snsw-gel/react';
import {InPageAlertProps} from '@snsw-gel/in-page-alert/src/InPageAlert';
// Define the allowed variant types

export interface AlertMessageProps {
    readonly title: string;
    /** List of paragraphs to be displayed to the user */
    readonly messages: readonly string[];
    /** The variant/type of the alert message. E.g., INFO, WARNING, ERROR, etc. */
    readonly messageVariant: InPageAlertProps['variant'];
}

export const AlertMessage: React.FC<AlertMessageProps> = (
    {
        title,
        messages,
        messageVariant,
    },
) => <InPageAlert
    title={title}
    variant={messageVariant}
>
    {messages.map((message) => <p key={message}>{message}</p>)}
</InPageAlert>;
